<vsf-dropdown
    #dropdown="vsfDropdown"
    [position]="['bottom-left', 'bottom-right']"
    [closeButton]='closeButton'
    [closeOnItemClick]="closeOnItemClick"
    [closeOnTriggerClick]="true"
>
    <div vsfDropdownTrigger class="block">
        <button
            class="group flex w-full justify-between text-sm font-medium text-gray-600 hover:text-gray-900"
        >
            <div class="mr-1">
                <ng-content [kbartComboBoxLabel]></ng-content>
            </div>
            <fa-icon [icon]="chevronDown" class="text-gray-500"></fa-icon>
        </button>
    </div>
    <div class="divide-y divide-gray-200" vsfDropdownContent>
        <button
            *ngFor="let item of items"
            (click)="itemClick.emit(item)"
            class="block w-full text-left font-medium text-gray-500 hover:bg-gray-50 hover:text-gray-900 block px-4 py-2 text-sm"
        >
            <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item }"></ng-container>
        </button>
    </div>
</vsf-dropdown>
